import { i18n } from '@/i18n';
import type { BillingContact, ValidationError } from '../types';

/** Accepts billing contact shape (e.g. ApplePayPaymentContact); all fields optional. */
export const checkRequiredFields = (contact: BillingContact): ValidationError[] | null => {
  const {
    familyName = '',
    givenName = '',
    locality = '',
    addressLines = [],
    countryCode = '',
    postalCode = '',
  } = contact;
  const validationErrors: ValidationError[] = [];
  const address = addressLines.map((el: string) => el.trim()).filter(Boolean).join(', ');

  if (!familyName?.trim() || !givenName?.trim()) {
    validationErrors.push({ contactField: 'name', message: String(i18n.t('transaction-flow.apple-pay.validation.name')) });
  }

  if (!locality?.trim()) {
    validationErrors.push({ contactField: 'locality', message: String(i18n.t('validators.billing-address.aft.city.required')) });
  }

  // check if there is at least one letter in the city
  if (locality?.trim() && !/\p{L}/u.test(locality.trim())) {
    validationErrors.push({ contactField: 'locality', message: String(i18n.t('validators.billing-address.aft.city.invalid')) });
  }

  if (address.length === 0) {
    validationErrors.push({ contactField: 'addressLines', message: String(i18n.t('validators.billing-address.aft.address.required')) });
  }

  if (!countryCode) {
    validationErrors.push({ contactField: 'countryCode', message: String(i18n.t('validators.billing-address.aft.country.required')) });
  }

  if (!postalCode?.trim()) {
    validationErrors.push({ contactField: 'postalCode', message: String(i18n.t('validators.billing-address.aft.zip.required')) });
  }

  return validationErrors.length > 0 ? validationErrors : null;
};
